import isEqual from 'react-fast-compare';
import {useSelector} from 'react-redux';

export default function usePlatforms() {
    return useSelector((ctx: any) => ctx.platforms, isEqual);
};